var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "yxtbiz-flex-center" },
    [
      _c(
        "yxt-select",
        {
          ref: "select",
          staticClass: "yxtbiz-flex-1",
          attrs: { disabled: _vm.disabled },
          on: { "visible-change": _vm.visibleChange },
          model: {
            value: _vm.name,
            callback: function ($$v) {
              _vm.name = $$v
            },
            expression: "name",
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.catalogData.loading,
                  expression: "catalogData.loading",
                },
              ],
              staticClass: "yxtbiz-kng-operator__catalog-tree",
              attrs: { slot: "empty" },
              slot: "empty",
            },
            [
              _c("yxt-input", {
                staticClass: "mb8",
                attrs: {
                  placeholder: _vm.$t(
                    "pc_kng_kngcourse_msg_pea4" /* 请输入课程分类名称搜索 */
                  ),
                  searchable: "",
                  autofocus: "",
                },
                model: {
                  value: _vm.catalogFilterValue,
                  callback: function ($$v) {
                    _vm.catalogFilterValue = $$v
                  },
                  expression: "catalogFilterValue",
                },
              }),
              _vm.showTree
                ? _c("yxt-tree", {
                    ref: "tree",
                    attrs: {
                      virtual: "",
                      "node-key": "id",
                      "expand-on-click-node": false,
                      data: _vm.catalogData.tree,
                      "filter-node-method": _vm.filterNode,
                      "current-node-key": _vm.id,
                      "default-expanded-keys": [_vm.id],
                    },
                    on: { "node-click": _vm.clickTreeNode },
                  })
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm.enableAddCatalog
        ? _c(
            "yxt-button",
            {
              staticClass: "ml12",
              attrs: { disabled: _vm.disabled },
              on: { click: _vm.add },
            },
            [
              _vm._v(
                _vm._s(_vm.$t("pc_kng_catalogmgmt_btn_add" /** 新增分类 */))
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }